import http from '../plugins/axios';

export default {
  async index() {
    const response = await http.get('/api/client')
    
    return response.data
  }
}